export default __webpack_public_path__ + "static/media/pizza.8c52ebf9.svg";